/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */

import { actions as CommonActions } from '../reducers/app';

export default function onlineListener(dispatch) {
	window.addEventListener('online', updateOnlineStatus);
	window.addEventListener('offline', updateOnlineStatus);
	
	function updateOnlineStatus() {
		// console.log('Online status: ' + event.type);
		if (navigator.onLine) {
			dispatch(CommonActions.goOnline());
			dispatch(CommonActions.showNotification(
				'Connected.',
				true,
				true,
				'success'
			));
		} else {
			dispatch(CommonActions.goOffline());
			dispatch(CommonActions.showNotification(
				'No Internet Connection. Please check your connectivity.',
				true,
				true,
				'info'
			));
		}
	}
}
